import React, { useEffect, useState } from "react";
import flag_2 from "./../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../api";
import { useTableDataGenerator } from "../helper/common";
import MainLayout from "../layout/main";
import Loading from "../component/loading";
import { toDateString } from "../helper/dateHelper";
import { MdOutlineFileDownload } from "react-icons/md";
import Pagination from "../component/pagination";
import { Table } from "../component/table";
import { useFileDownloader } from "../api/fileDownloader";
import { useAlert } from "react-alert";
import { storageApi } from "../storage/storageApi";
import { Input } from "../component/input";
import { IoClose } from "react-icons/io5";
import { SelectOption } from "../component/selectOption";
import { FaAngleLeft } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";

const GuidePage = () => {
  let [[guideList], { fetch: fetchGuides, loading }] = useApiCall({
    endpoints: ApiEndpoints.about.guideList,
  });
  const { data } = useTableDataGenerator(guideList?.data ?? [], {
    pageSize: 10000,
  });
  const [title, setTitle] = useState("");
  const [state, setState] = useState("all");
  const [majmooe, setMajmooe] = useState("all");
  const downloadManager = useFileDownloader();
  const [showModal, setShowModal] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userProfile = storageApi.useGetUser();
  const [[departmentList, stateList]] = useApiCall({
    endpoints: [ApiEndpoints.user.departmentList, ApiEndpoints.user.stateList],
  });
  const [id, setId] = useState(0);

  const onChangeModal = () => {
    setShowModal(true);
  };
  const hideModal = () => {
    setShowModal(false);
    setState("all");
    setMajmooe("all");
    setTitle("");
    setPdfFiles([]);
  };
  const alert = useAlert();
  const [, { fetch: uploadPDFApi }] = useApiCall({
    endpoints: ApiEndpoints.about.announcementCreate,
    payload: {
      file: pdfFiles[0],
      title,
      type: "راهنما",
      state: state === "all" ? "" : state,
      majmooe: majmooe === "all" ? "" : majmooe,
    },
    lazy: true,
  });
  const [, { loading: deleteLoading, fetch: reportDeleteApi }] = useApiCall({
    endpoints: ApiEndpoints.about.guideDelete,
    payload: id,
    lazy: true,
  });
  const submitForm = async () => {
    setIsLoading(true);
    const [uploadPDFResponse] = await uploadPDFApi();
    if (uploadPDFResponse.isOk) {
      setIsLoading(false);
      alert.success("ایجاد موفق");
      hideModal();
      handleGetGuides();
    } else {
      setIsLoading(false);
    }
  };
  const onAddImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      for (const files of e.target.files) {
        const reader = new FileReader();
        reader.onload = function (e) {
          setPdfFiles([files]);
        };
        reader.readAsDataURL(files);
      }
    }
  };
  useEffect(() => {
    handleGetGuides();
  }, []);
  const handleGetGuides = () => {
    guideList = fetchGuides();
  };
  const onProgramDeleteClick = (item) => {
    confirmAlert({
      title: "",
      message: "آیا از حذف راهنما مطمئن هستید ؟",
      buttons: [
        {
          label: (
            <div>
              بله
              <Loading isLoading={loading} />
            </div>
          ),
          onClick: async () => {
            const [{ isOk }] = await reportDeleteApi({
              id: item.id,
            });
            if (isOk) {
              window.location.reload();
            }
          },
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    });
  };
  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8 min-h-[180px]">
          <img src={flag_2} className=" absolute left-0 top-0 h-42" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="text-3xl text-center font-bold">
              <span className=" text-greenblue">راهنما</span>
            </div>
            {/* form search list */}
          </div>
        </div>
        {userProfile.role === "admin" && (
          <button
            onClick={() => onChangeModal()}
            className="flex gap-1 bg-green-200 text-green-700 px-3 py-2 rounded-xl w-32 self-end"
          >
            افزودن
            <span className="mr-9">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            </span>
          </button>
        )}
        <Table
          loading={loading}
          data={data}
          header={[
            {
              name: "ردیف",
              width: 2,
              render: (i) => i.rowIndex,
            },
            {
              name: "عنوان",
              width: 5,
              render: (i) => i.title,
            },
            {
              name: "نوع",
              width: 3,
              render: (i) => (
                <span className="p-2 -x-4 rounded-lg border-gray-200 bg-white border-[1.5px] text-sm text-gray-500">
                  {i.type}
                </span>
              ),
            },
            {
              name: "عملیات",
              width: 2,
              render: (i) => {
                const isDownloading = downloadManager.isLoading(i.file);
                return (
                  <div className={"w-full justify-around flex items-center"}>
                    <button
                      disabled={isDownloading}
                      onClick={() =>
                        !isDownloading &&
                        downloadManager.download({ url: i.file })
                      }
                      className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                    >
                      دانلود
                      <Loading isLoading={isDownloading} color={"blue"} />
                      {!isDownloading && <MdOutlineFileDownload size={20} />}
                    </button>
                    {userProfile.role === "admin" && (
                      <div
                        onClick={() => onProgramDeleteClick(i)}
                        className="max-w-[90%] cursor-pointer gap-1 bg-red-100 text-red-500 px-3 py-2 rounded-xl flex justify-center items-center"
                      >
                        حذف از سامانه
                        <FaAngleLeft />
                      </div>
                    )}
                  </div>
                );
              },
            },
          ]}
        />
      </div>
      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              افزودن راهنما
            </div>
            <div className="flex f justify-center flex-col mt-10 w-5/12 self-center">
              {(userProfile.role === "organization_manager" ||
                userProfile.role === "state_organization_manager") && (
                <div className="form-field w-full relative mt-2">
                  <Input
                    type="text"
                    placeholder="وارد کنید"
                    label="عنوان"
                    value={title}
                    onChange={(e) => {
                      setTitle(e);
                    }}
                  />
                </div>
              )}
              {userProfile.role === "admin" && (
                <>
                  <div className="w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="عنوان"
                        value={title}
                        onChange={(e) => {
                          setTitle(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="نام مجموعه"
                        value={majmooe}
                        options={[
                          {
                            label: "همه مجموعه ها",
                            value: "all",
                          },
                        ].concat(
                          departmentList?.data?.map((c) => ({
                            label: c.title,
                            value: c.id,
                          })),
                        )}
                        onChange={(e) => {
                          setMajmooe(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="استان"
                        value={state}
                        options={[
                          {
                            label: "همه استان ها",
                            value: "all",
                          },
                        ].concat(
                          stateList?.data?.map((c) => ({
                            label: c.name,
                            value: c.id,
                          })),
                        )}
                        onChange={(e) => {
                          setState(e.value);
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="w-5/12 my-0 mx-auto">
              <label
                htmlFor="file-upload"
                className="mt-10 cursor-pointer flex justify-center items-center px-3 py-2 bg-blue-500 text-white rounded-xl"
              >
                افزودن فایل pdf{" "}
                <input
                  id="file-upload"
                  type="file"
                  className="hidden"
                  onChange={onAddImage}
                />
              </label>
              {pdfFiles.length > 0 &&
                pdfFiles.map((pdfFile, index) => (
                  <div key={index} className="border-2 mt-2 p-2">
                    نام فایل:
                    {pdfFile.name}
                    <br />
                    سایز:
                    {pdfFile.size / 1000}
                    کیلوبایت
                  </div>
                ))}
            </div>
            <div className="flex justify-center mt-10">
              <button
                onClick={submitForm}
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
              >
                ذخیره
                <Loading isLoading={isLoading} />
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default GuidePage;
